import { useState } from 'react';
import styled from 'styled-components';
import { getTextStyle } from '../../../content/texts/bou-text/text-style';
import { BouColor } from '../../../global/bou-colors';
import { useTimeout } from '../../../hooks/external/use-timeout';
import { BouSpacingLevel, fluidSpacing } from '../../../layout/bou-spacing';
import { BouSpinner, BouSpinnerSize } from './bou-spinner';

/**
 * Loading for whole app
 *
 * (Situation where we aren't yet even showing a header with logo)
 */
export function BouAppLoading() {
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
  useTimeout(() => void setShowDisclaimer(true), 35 * 1000);

  return (
    <Root>
      <BouSpinner size={BouSpinnerSize.LARGE} showLogo={true} />
      {
        <Text visible={showDisclaimer}>
          This is taking longer than expected. <br />
          There is likely an issue either with our servers or with your connection. <br />
          Please try reloading the page.
        </Text>
      }
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const Text = styled.p<{ visible: boolean }>`
  ${getTextStyle({ size: 'small' })}
  ${fluidSpacing('margin-top', BouSpacingLevel.SMALL)}
  text-align: center;
  opacity: ${props => (props.visible ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  cursor: ${props => (props.visible ? 'text' : 'default')};
  color: ${BouColor.TOOL_TEXT_DARK_GRAY};
`;
